import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from './question-base';
import { QuestionControlService } from './question-control.service';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { quantile } from 'd3';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [QuestionControlService],
})
export class DynamicFormComponent implements OnInit {
  @Output() sendData = new EventEmitter<any>();
  @Input() questions: QuestionBase<string>[] | null = [];
  @Output() imgType: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() fileUploadMessage: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deleteLink: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkBoxChange : EventEmitter<boolean> = new EventEmitter<any>();

  uploadingFile: boolean = false;
  uploadProgress: number = 0;
  form!: FormGroup;
  payLoad = '';
  images: any = {};
  private translator: TranslatorPipe = new TranslatorPipe();

  translate(key: string): string {
    return this.translator.transform(key);
  }

  constructor(
    private qcs: QuestionControlService,
    private imageUploadService: ImageuploadService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);
  }

  handleDeleteLink(link: any) {
    this.deleteLink.emit(link);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['questions']) {
      this.questions = changes['questions'].currentValue;
      this.ngOnInit();
    }
  }

  resetForm() {
    this.form.reset();
    console.log('==reset');
  }

  async onSubmit() {
    let formData = this.form.getRawValue();
    if (formData.hasOwnProperty('active')) {
      if (formData.active == undefined || formData.active == null) {
        formData.active = true;
      }
    }
    console.log
    let requiredFailed = false;
    this.questions?.forEach((q) => {
      console.log('REQUIRED CHECK',q.required,q.isImage)
      if (q.isImage && q.required) {
        console.log('REQUIRED CHECK',q);
        if (!this.images.hasOwnProperty(q.key)) {
          this.sendData.emit(`Please select ${q.key}`);
          requiredFailed = true;
          return;
        }
      }
    });

    if (requiredFailed) {
      return;
    }

    for (let image in this.images) {
      if (image) {
        let res = await this.imageUploadService.uploadImage(this.images[image].file, this.images[image].type);
        console.log('IMAGE', res);
        if (res.error) {
          this.sendData.emit(res.msg);
          return;
        }
        formData[image] = res.data;
      }
    }

    console.log(formData);
    this.sendData.emit(formData);

    // this.payLoad = JSON.stringify(this.form.getRawValue());
    // console.log(this.payLoad);
  }

  async handleFileUpload(file: any) {
    this.uploadingFile = true;
    this.imageUploadService.uploadImageWithProgress(file.file.file, file.file.type).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            console.log(`Uploaded! ${this.uploadProgress}%`);
            break;
          case HttpEventType.Response:
            console.log('UPLOAD EVENT', event);
            if (event.ok) {
              let obj: any = {
                name: file.file.file.name,
                message: this.translate("File Upload Successfully"),
           
                error: false,
                link: event.body.data
              }
              this.fileUploadMessage.emit(obj);
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
            } else {
              let obj: any = {
                message: "Failed to upload file",
                error: true
              }
              this.fileUploadMessage.emit(obj)
            }

        }
      },
      error: (error) => {
        console.log('UPLOAD ERROR', error);
        this.uploadingFile = false;
        this.uploadProgress = 0;
        let obj: any = {
          message: "Failed to upload file",
          error: true
        }
        this.fileUploadMessage.emit(obj)
      },
      complete: () => {
        this.uploadingFile = false;
        this.uploadProgress = 0;
      }
    })
  }


  handleImage(event: any) {
    for (let key in event) {
      this.images[key] = event[key];
    }
    console.log(this.images);
  }

  isVisible(value: string): boolean {
    try {
      const func = new Function(`return (${value})`);
      return func.call(this); // Ensure it always returns a boolean.
    } catch (error) {
      console.error("Invalid expression:", value, error);
      return false;
    }
  }
  

  onImgTypeChange(event: any) {
    console.log('FROM FORM', event);
    this.imgType.emit(event);
  }


  checkBoxChanged($event:any){
    this.checkBoxChange.emit(this.form.getRawValue());
  }

}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
